module.exports = __webpack_public_path__ + "static/media/panosta-svg-300x100.65cb5669.svg";